(() => {
  if (window.productCardGroupOptionsInitialized) return;
  window.productCardGroupOptionsInitialized = true;

  document.addEventListener('click', (event) => {
    const option = event.target.closest('[data-product-group-option]');
    if (!option) return;

    // Keep the browser's normal open-in-new-tab/window behaviour.
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

    const group = option.closest('[data-product-group]');
    const card = option.closest('.m-product-card');
    if (!group || !card) return;

    event.preventDefault();

    group.querySelectorAll('[data-product-group-option]').forEach((node) => {
      node.removeAttribute('data-selected');
      node.removeAttribute('aria-current');
    });
    option.dataset.selected = 'true';
    option.setAttribute('aria-current', 'true');

    const { productUrl, productTitle, productImage, productImageAlt, productHoverImage } = option.dataset;

    card.querySelectorAll('.m-product-card__link, .m-product-card__name').forEach((link) => {
      link.href = productUrl;
    });

    const title = card.querySelector('.m-product-card__name');
    if (title) title.textContent = productTitle;

    const mainImage = card.querySelector('.m-product-card__main-image img');
    if (mainImage && productImage) {
      mainImage.src = productImage;
      mainImage.removeAttribute('srcset');
      mainImage.removeAttribute('data-srcset');
      mainImage.alt = productImageAlt || productTitle;
    }

    const hoverImageWrapper = card.querySelector('.m-product-card__hover-image');
    const hoverImage = hoverImageWrapper && hoverImageWrapper.querySelector('img');
    if (hoverImageWrapper) hoverImageWrapper.hidden = !productHoverImage;
    if (hoverImage && productHoverImage) {
      hoverImage.src = productHoverImage;
      hoverImage.removeAttribute('srcset');
      hoverImage.removeAttribute('data-srcset');
      hoverImage.alt = productImageAlt || productTitle;
    }
  });
})();
